<template>
  <div>
    <v-dialog v-resize="onResize" v-model="dialogLocal" :max-width="windowSize.x * 0.8" @click:outside="$emit('hide', false)">
      <v-container fluid class="pa-md-0" v-if="render">

        <v-card class="pa-md-4 mx-md-auto">
          <v-row>
            <v-col>
              <v-card-title class="text-h5">
                {{$_t('Available columns')}}
              </v-card-title>
              <v-card-text>
                <v-simple-table
                fixed-header
                :height="windowSize.y * 0.7"
                >
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          {{$_t('Column name')}}
                        </th>
                        <th class="text-left">
                          {{$_t('On/Off')}}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in getAllColumns" :key="index">
                        <td>{{ item.text }}</td>
                        <td>
                          <v-switch
                            v-model="item.selected"
                            inset
                            @change="columnsSelected(item)"
                          ></v-switch>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
            </v-col>
            <v-col>
              <v-card-title class="text-h5">
                {{$_t('Selected columns')}}<br>&nbsp;
              </v-card-title>
              <v-list-item-subtitle class="subtitle-2"> {{$_t('You can drag and drop columns')}}</v-list-item-subtitle>
              <v-spacer></v-spacer>
              <v-card-text>
                 <v-simple-table
                fixed-header
                :height="windowSize.y * 0.7"
                >
                <v-list subheader two-line>
                  <draggable v-model="dragSelected" @end="endDrag">
                  <v-list-item v-for="(item, index) in dragSelected" :key="index" class="border mb-sm-1">
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="getTitle(item)"
                      ></v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn icon>
                        <v-icon color="grey lighten-1" @click="removeSelected(item)">mdi-trash-can</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                  </draggable>
                </v-list>
                 </v-simple-table>
              </v-card-text>
            </v-col>
          </v-row>

          <v-card-actions>
             <v-switch
                v-if="permitSortColumns"
                v-model="sortColumnsOnGrid"
                inset
                :label="$_t('Permit to sort columns directly on grid')"
              >
              </v-switch>
            <v-spacer></v-spacer>
            <v-btn color="secondary" @click="$emit('hide', false)">
              {{$_t('Close')}}
            </v-btn>

            <v-btn color="primary" @click="$emit('save')">
              {{$_t('Save')}}
            </v-btn>
          </v-card-actions>
        </v-card>

      </v-container>
    </v-dialog>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
export default {
  name: 'GridColumns',
   components: {
    draggable,
  },
  props: {
    dialog: Boolean,
    allColumns: Array,
    selectedColumns: Array,
    headersPresetType: {
      type: String,
      default: ''
    },
    storageKey: {
      type: String,
      default: 'gridColumnsSelection'
    },
    columnsVersion: {
      type: String,
      default: '1.0.0'
    },
    render:{
      type: Boolean,
      default: true
    },
    permitSortColumns:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      dragSelected:[],
      windowSize: {x:0,y:0}
    };
  },
  computed:{
    dialogLocal: {
      get() {
        return this.dialog
      },
      set(val) {
        this.$emit('update:dialog', val)
      }
    },
    getAllColumns() {
      return this.allColumns
    },
    getSelectedColumns: {
    // getter
      get: function () {
        return this.selectedColumns
      },
      // setter
      set: function (newValue) {
        this.selectedColumns = newValue
      }
    },
    sortColumnsOnGrid: {
        get: function () {
          return this.$store.getters['app/getSortColumnsOnGrid']
        },
        set: function (newValue) {
          this.$store.commit('app/setSortColumnsOnGrid',newValue)
        }
      }
  },
  methods: {
    onResize () {
        this.windowSize = { x: window.innerWidth, y: window.innerHeight }
      },
    
    saveColumnsToStorage() {
      if (!this.headersPresetType) return
      
      try {
        const storageData = JSON.parse(localStorage.getItem(this.storageKey) || '{}')
        
        storageData[this.headersPresetType] = {
          version: this.columnsVersion,
          columns: this.selectedColumns,
          timestamp: new Date().toISOString()
        }
        
        localStorage.setItem(this.storageKey, JSON.stringify(storageData))
      } catch (error) {
        console.error('Error saving grid columns to localStorage:', error)
      }
    },
    
    loadColumnsFromStorage() {
      if (!this.headersPresetType) {
        return null
      } 
      
      try {
        const storageData = JSON.parse(localStorage.getItem(this.storageKey) || '{}')
        const presetData = storageData[this.headersPresetType]
        
        if (!presetData) {
          return null
        } 
        
        // Check version
        if (presetData.version !== this.columnsVersion) {
          console.error(`Grid columns version mismatch for ${this.headersPresetType}. Using store values.`)
          return null
        }
        
        return presetData.columns
      } catch (error) {
        console.error('Error loading grid columns from localStorage:', error)
        return null
      }
    },
    
    filterValidColumns(columns) {
      // Filter out items that don't exist in allColumns to fix the drag & drop bug (displaying empty items)
      if (!Array.isArray(columns) || !Array.isArray(this.allColumns)) {
        return []
      }
      
      const validColumnValues = this.allColumns.map(col => col.value)
      return columns.filter(col => validColumnValues.includes(col))
    },
    
    endDrag(){
      this.$emit('drop',this.dragSelected)
    },
    columnsSelected(item,force=false) {
      if(force) {
        item.selected = false
      }
      if (item.selected) {
        this.selectedColumns.push(item.value)
      } else {
        const index = this.selectedColumns.indexOf(item.value)
        if (index > -1) {
          this.selectedColumns.splice(index, 1)
        }
      }
      this.saveColumnsToStorage()
    },
    removeSelected(item) {
      const index = this.selectedColumns.indexOf(item)
        if (index > -1) {
          this.selectedColumns.splice(index, 1)
        }
      this.saveColumnsToStorage()
    },
    getTitle(item){
      const found = this.allColumns.find(el=>el.value === item)
      return found ? found.text : ''
    },
    
    initializeSavedColumns() {
      const savedColumns = this.loadColumnsFromStorage()
      if (!savedColumns || savedColumns.length === 0) {
        return
      }
      
      const validColumns = this.filterValidColumns(savedColumns)
      if (validColumns.length === 0) {
        return
      }
      
      // Sync to store if conditions are met
      if (this.headersPresetType && this.$store.getters['app/currentUser']) {
        this.$store.dispatch('app/setColumnsByPresetType', {
          presetType: this.headersPresetType,
          columns: validColumns
        })
      }
      
      this.$emit('update:selectedColumns', validColumns)
    }
  },
  watch:{
    getSelectedColumns(val){
      // Filter out invalid columns before setting dragSelected (fixes empty items bug)
      this.dragSelected = this.filterValidColumns([...val])
    }
  },
  mounted(){
    this.initializeSavedColumns()
  }
};
</script>
<style scoped>
  .border {
    border: 1px dashed orange !important;
  }
</style>
